import { useEffect, useState } from "react";
import { FiEye } from "react-icons/fi";
import { FaCarAlt } from "react-icons/fa";
import { ChevronRight, Phone, Calendar, Gauge, Fuel } from "lucide-react";
import Button from "../components/ui/Button";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  onSnapshot,
  getDoc,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { formatMoney } from "../utils/formatMoney";
import { retiraMascara } from "../utils/retiraMascara";
import WhatsappFloatButton from "../components/WhatsappFloatButton";
import HeroSection from "../components/HeroSection";

const firestore = getFirestore(app);

export default function Home() {
  const [veiculos, setVeiculos] = useState([]);
  const [revenda, setRevenda] = useState({});
  const [filtros, setFiltros] = useState({ marca: "", modelo: "", ano: "" });
  const [filtrosAvancados, setFiltrosAvancados] = useState({
    tipo: "",
    cor: "",
    portas: "",
    kmMax: "",
    precoMin: "",
    precoMax: "",
  });
  const [, setErroFiltro] = useState("");

  const navigate = useNavigate();
  const [telefone, setTelefone] = useState("");



  useEffect(() => {
    window.scrollTo(0, 0);

    const revendaRef = doc(collection(firestore, "revenda"), id_firebase);
    getDoc(revendaRef).then((docSnap) => {
      if (docSnap.exists()) {
        setRevenda(docSnap.data());
        setTelefone(retiraMascara(docSnap.data().petelefone2, "link"));
      }
    });

    const q = query(
      collection(doc(collection(firestore, "revenda"), id_firebase), "veiculos"),
      where("veremovido", "==", 0),
      where("vevendido", "==", 0),
      orderBy("updated_at", "desc")
    );

    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const items = [];
      querySnapshot.forEach((doc) => {
        const document = doc.data();
        document.id = doc.id;
        if (document["veexibir_site"] !== false) {
          items.push(document);
        }
      });
      setVeiculos(items);
    });

    return () => unsubscribe();
  }, []);

  function getOpcoesFiltro(campo, marcaSelecionada = "") {
    const modelosFiltrados = veiculos.filter((veiculo) => {
      if (campo === "vefipe_name" && marcaSelecionada) {
        return veiculo.vefipe_marca === marcaSelecionada;
      }
      return true;
    });

    const opcoes = modelosFiltrados
      .map((veiculo) => veiculo[campo])
      .filter((valor, index, self) => valor && self.indexOf(valor) === index);

    return opcoes.sort();
  }

  const handleBuscar = () => {
    if (
      !filtros.marca &&
      !filtros.modelo &&
      !filtros.ano &&
      !Object.values(filtrosAvancados).some((value) => value)
    ) {
      setErroFiltro("Selecione pelo menos um filtro.");
      return;
    }

    const params = new URLSearchParams();
    // Mapeia os nomes dos filtros para os nomes dos campos do veículo
    if (filtros.marca) params.append("vefipe_marca", filtros.marca);
    if (filtros.modelo) params.append("vefipe_name", filtros.modelo);
    if (filtros.ano) params.append("vefipe_ano_modelo", filtros.ano);

    Object.entries(filtrosAvancados).forEach(([key, value]) => {
      if (value) {
        params.append(key, value);
      }
    });

    setErroFiltro("");
    navigate(`/estoque?${params.toString()}`);
  };

  function separarNomeVeiculo(nomeCompleto) {
    if (!nomeCompleto) return { mainName: '', subName: '' };

    const palavras = nomeCompleto.split(' ');

    const STOP_WORDS = [
      'CD', 'SR', 'SRV', 'GR', 'XEI', 'LTZ', 'LX',
      '4X4', '4X2',
      '1.0', '1.2', '1.3', '1.4', '1.5', '1.8', '1.6', '2.0', '2.8',
      'TDI', 'TURBO', 'DIESEL', 'FLEX',
      'AUT', 'AUT.', 'MT', 'CVT'
    ];

    const indexSpec = palavras.findIndex(p =>
      STOP_WORDS.includes(p)
    );

    if (indexSpec === -1) {
      return {
        mainName: palavras.slice(0, 1).join(' '),
        subName: palavras.slice(1).join(' ')
      };
    }

    return {
      mainName: palavras.slice(0, indexSpec).join(' '),
      subName: palavras.slice(indexSpec).join(' ')
    };
  }



  return (
    <div className="min-h-screen w-full bg-background">
      <Header />
      <WhatsappFloatButton />


      <section className="bg-background mb-12">
        
        <div className="container mx-auto px-6">
          <HeroSection />
          <div>
            <div className="text-center mb-16 mt-12">
              <span className="inline-block px-4 py-2 mb-4 text-sm font-semibold tracking-widest uppercase text-primary border border-primary/30 rounded-full">
                Estoque
              </span>
              <h2 className="text-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-4">
                Carros em <span className="text-primary">Destaque</span>
              </h2>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mx-auto px-4">
              {veiculos
                .slice()
                .sort(() => Math.random() - 0.5)
                .map((veiculo) => {

                  const { mainName, subName } = separarNomeVeiculo(
                    veiculo.vefipe_name
                  );

                  const cambio = veiculo.vecambio === 'A' ? 'Automático' : veiculo.vecambio === 'M' ? 'Manual' : veiculo.vecambio;

                  veiculo.vecambio = cambio;

                  return (
                    <a href={`/veiculo/${veiculo.id}`}
                      key={veiculo.id}
                      className="group relative bg-white rounded-2xl overflow-hidden border border-gray-100 hover:border-blue-200 hover:shadow-lg transition-all duration-300 min-w-[280px] max-w-[320px] flex flex-col">

                      {/* Imagem */}
                      < div className="relative h-48 overflow-hidden bg-gray-50" >
                        <img
                          className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500"
                          src={veiculo.imagens[0]?.fileUrl}
                          alt={veiculo.titulo}
                        />
                        {/* Ano badge */}
                        <div div className="absolute top-3 left-3 bg-black/70 text-white text-xs font-semibold px-2.5 py-1 rounded-md" >
                          {veiculo.veano_fabricacao}
                        </div>
                      </div>

                      {/* Corpo */}
                      <div className="p-4 flex flex-col gap-3 flex-1">

                        {/* Nome */}
                        <div>
                          <h3 className="text-base font-black text-gray-900 uppercase leading-tight tracking-wide">
                            {veiculo.vefipe_marca} {mainName}
                          </h3>
                          {subName && (
                            <p className="text-xs text-gray-400 uppercase mt-0.5 tracking-wider">
                              {subName}
                            </p>
                          )}
                        </div>

                        {/* Specs */}
                        <div className="flex flex-col gap-1.5">
                          <div className="flex items-center gap-2 text-gray-500 text-sm">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
                            </svg>
                            {veiculo.vecambio === 'A' ? 'Automático' : 'Manual'}
                          </div>
                          <div className="flex items-center gap-2 text-gray-500 text-sm">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                              <path strokeLinecap="round" strokeLinejoin="round" d="M15.362 5.214A8.252 8.252 0 0112 21 8.25 8.25 0 016.038 7.048 8.287 8.287 0 009 9.6a8.983 8.983 0 013.361-6.867 8.21 8.21 0 003 2.48z" />
                            </svg>
                            {veiculo.vefipe_combustivel}
                          </div>
                        </div>

                        {/* Divider */}
                        <div className="h-px bg-gray-100 mt-auto" />

                        {/* Preço + botão */}
                        <div className="flex items-center justify-between">
                          <div className="bg-blue-600 text-white text-sm font-bold px-4 py-2 rounded-xl">
                            {veiculo.vevalor
                              ? formatMoney(veiculo.vevalor)
                              : 'Consulte'}
                          </div>
                          <button className="flex items-center gap-1.5 text-xs font-medium text-gray-500 hover:text-blue-600 transition-colors">
                            <FiEye className="w-4 h-4" />
                            Ver mais
                          </button>
                        </div>

                      </div>
                    </a>
                  );
                })}

            </div>
          </div >
        </div >

      </section >



      <Footer />
    </div >
  );
}
